import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UiKitLibModule } from 'ui-kit-lib';

import { SharedModule } from '../shared/shared.module';
import { TranslationModule } from '../translate/translation.module';
import { AddonsSelectComponent } from './components/addons-select/addons-select.component';
import { ConsentFormComponent } from './components/consent-form/consent-form.component';
import { DebugInfoComponent } from './components/debug-info/debug-info.component';
import { DisplayInputCheckboxToggleComponent } from './components/display-input-checkbox-toggle/display-input-checkbox-toggle.component';
import { DisplayInputCheckboxComponent } from './components/display-input-checkbox/display-input-checkbox.component';
import { DisplayInputRadioComponent } from './components/display-input-radio/display-input-radio.component';
import { FormAddressComponent } from './components/form-address/form-address.component';
import { NavigationButtonsComponent } from './components/navigation-buttons/navigation-buttons.component';
import { ProcessComponent } from './components/process/process.component';
import { RedirectingSiaPaymentComponent } from './components/redirecting-sia-payment/redirecting-sia-payment.component';
import { ActivationOtpComponent } from './components/steps/activation-otp/activation-otp.component';
import { ActivationComponent } from './components/steps/activation/activation.component';
import { AddressComponent } from './components/steps/address/address.component';
import {ConsentsComponent} from './components/steps/consents/consents.component';
import { ContactsComponent } from './components/steps/contacts/contacts.component';
import {CouponComponent} from './components/steps/coupon/coupon.component';
import { CustomerComponent } from './components/steps/customer/customer.component';
import { DigitalOnboardingIccidComponent } from './components/steps/digital-onboarding-iccid/digital-onboarding-iccid.component';
import { DocumentComponent } from './components/steps/document/document.component';
import {OfferExtrasComponent} from './components/steps/offer-extras/offer-extras.component';
import { PaymentMethodComponent } from './components/steps/payment-method/payment-method.component';
import { PaymentComponent } from './components/steps/payment/payment.component';
import { ShippingMethodComponent } from './components/steps/shipping-method/shipping-method.component';
import { SimTypeComponent } from './components/steps/sim-type/sim-type.component';
import {SummaryComponent} from './components/steps/summary/summary.component';
import { WinbackComponent } from './components/steps/winback/winback.component';
import { BackUrlGuard } from './guards/back-url/back-url.guard';
import { CanDeactivateGuard } from './guards/can-deactivate/can-deactivate.guard';
import { ProcessRoutingModule } from './process-routing.module';

@NgModule({
  declarations: [
    ActivationComponent,
    AddressComponent,
    ContactsComponent,
    CouponComponent,
    CustomerComponent,
    DigitalOnboardingIccidComponent,
    DocumentComponent,
    DebugInfoComponent,
    DisplayInputRadioComponent,
    FormAddressComponent,
    NavigationButtonsComponent,
    OfferExtrasComponent,
    PaymentMethodComponent,
    ProcessComponent,
    ConsentsComponent,
    ShippingMethodComponent,
    SimTypeComponent,
    SummaryComponent,
    PaymentComponent,
    RedirectingSiaPaymentComponent,
    WinbackComponent,
    ConsentFormComponent,
    ActivationOtpComponent,
    DisplayInputCheckboxComponent,
    DisplayInputCheckboxToggleComponent,
    AddonsSelectComponent,
  ],
  providers: [
    BackUrlGuard,
    CanDeactivateGuard
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Custom
    TranslationModule.forRoot(),
    // CartModule,
    SharedModule,
    ProcessRoutingModule,
    UiKitLibModule
  ]
})
export class ProcessModule {}
